import React, { ReactNode, forwardRef } from "react"

import { cn } from "../../../shared/utils/cn"
import { options } from "../../../types"

export enum ContainerType {
    Default = "default",
    Article = "article",
    Redesign = "redesign",
}

interface ContainerProps {
    children: ReactNode
    className?: string
    type?: ContainerType
}

const Container = forwardRef<HTMLDivElement, ContainerProps>(
    ({ children, className, type = ContainerType.Default }, forwardedRef) => {
        return (
            <div
                className={cn(
                    "mx-auto box-border w-full px-6.25 md:px-10 lg:px-15",
                    {
                        "lg:max-w-[1560px]": type === ContainerType.Default,
                        "sm:box-content sm:max-w-[600px] lg:max-w-[900px]": type === ContainerType.Article,
                        "xs:px-10 sm:px-15 md:px-20 lg:max-w-[1680px] lg:px-30": type === ContainerType.Redesign,
                    },
                    className
                )}
                ref={forwardedRef}
            >
                {children}
            </div>
        )
    }
)

export const containerTypeOptions = options<typeof ContainerType>(ContainerType)

export default Container
